<template>
    <div>
        <div v-if="$refs.creationForm && $refs.creationForm.values[4] =='filled'" class="box-rules">
            <p>
                Votre mot de passe doit comporter <strong>8 caractères minimum</strong> avec, au moins : 
                <strong>1 majuscule</strong>, <strong>1 minuscule</strong>, <strong>1 chiffre</strong> et <strong>1 caractère spécial</strong>
            </p>
        </div>
        
        <resource-form ref="creationForm"
            :model="form.model"
            :schema="form.schema"
            :triggers="form.triggers"
            :no-form-group="true"
            @submit="onFormSubmit">
            <button type="button" slot="cancel" class="btn btn-default btn-sm" @click="onCancelButtonClick">
                Annuler
            </button>
        </resource-form>
    </div>
</template>

<script>
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        data() {
            return {
                form: {
                    model: {
                        "password_type": "generated"
                    },
                    schema: {
                        fields: [
                            {
                                "type": "text",
                                "label": "Prénom",
                                "model": "first_name",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            },
                            {
                                "type": "text",
                                "label": "Nom",
                                "model": "last_name",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            },
                            {
                                "type": "text",
                                "label": "Téléphone",
                                "model": "phone",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            },
                            {
                                "type": "email",
                                "label": "E-mail",
                                "model": "email",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            },
                            {
                                "type": "select",
                                "label": "Type de mot de passe",
                                "model": "password_type",
                                "values": [
                                    {"id": "generated", "name": "Généré automatiquement"},
                                    {"id": "filled", "name": "Saisi manuellement"}
                                ],
                                "readonly": false,
                                "default": "generated",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            },
                            {
                                "type": "password",
                                "label": "Mot de passe",
                                "model": "password",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            },
                            {
                                "type": "password",
                                "label": "Confirmation du mot de passe",
                                "model": "password_confirmation",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            },
                            {
                                "type": "switch",
                                "label": "Envoyer un mail à l'utilisateur ?",
                                "model": "send_email",
                                "default": false,
                                "disabled": false,
                                "help": "",
                                "hint": ""
                            }
                        ],
                        optional_fields: []
                    },
                    triggers: {
                        "password": 'password_type:filled',
                        "password_confirmation": 'password_type:filled'
                    }
                }
            }
        },

        components: {
            ResourceForm
        },

        methods: {
            storeUser(userModel) {
                // this.isLoading = true

                return this.$root.axios.post(`users`, userModel)
                    .then(() => {
                        // this.isLoading = false
                    })
            },

            onFormSubmit({ data: model }) {
                // Type forced to buyer
                Object.assign(model, {type: 'buyer'})

                this.storeUser(model)
                    .then(() => {
                        this.$emit('user-created')
                
                        // For modal handling
                        this.$parent.$emit('modal-closed')
                    })
            },

            onCancelButtonClick() {
                this.$emit('operation-canceled')
                
                // For modal handling
                this.$parent.$emit('modal-closed')
            }
        }
    }
</script>

<style lang="scss">
    .box-rules {
        background-color: #d9edf7;
        padding: 10px;
        margin-bottom: 10px;

        p {
            margin-bottom: 5px;
        }

        ul {
            padding-left: 15px;
            
            li {
                list-style: disc inside;
            }
        }
    }
    .required label:after {
        content: ' *';
        color: red;
    }
</style>


// WEBPACK FOOTER //
// client/components/Users/UserCreationForm.vue